<template>
        <b-carousel>
            <b-carousel-item v-for="(carousel, i) in carousels" :key="i">
                <a href="https://juntoscambiandovidas.org/">
                    <img class="imgSitioWeb" v-bind:src="carousel.image" v-bind:alt='carousel.text' :width="carousel.width"/>
                </a>
                <span class="nombreSitioWeb"> 
                    <h4> 
                        {{ carousel.nombre }}
                    </h4>
                </span>
            </b-carousel-item>
        </b-carousel>
</template>

<script>
export default {
    data(){
        return {
            carousels: [
                {
                    width: 550,
                    url: 'https://tresseiscincomx.com/',
                    nombre: '',
                    text: 'Sitio web de Noticias B.C.S.', 
                    image: 'images/body/Logo-365_blanco.png'
                },
                {
                    width: 200,
                    url: 'https://komvac.com/',
                    nombre: '',
                    text: 'Sitio web de venta de muebles', 
                    image: 'images/body/logo-mogal.svg'
                },
                {
                    width: 250,
                    url: 'https://komvac.com/',
                    text: 'Sitio web de Fotografias.', 
                    nombre: '',
                    image: 'images/body/logo_nostalgiasbcs.svg'
                },
                {
                    width: 350,
                    url: 'https://juntoscambiandovidas.org/',
                    nombre: '',
                    text: 'Sitio web Apoyar a personas con Parálisis Cerebral y otras discapacidades en situación económica vulnerable, Guadalajar Jalisco.',
                    image: 'images/body/Logo-Juntos-Cambiando-vidas.png'
                },
                {
                    width: 350,
                    url: 'https://komvac.com/',
                    nombre: '',
                    text: 'Concert Weddings, sitio web de bodas', 
                    image: 'images/body/logo_concertweddings.png'
                },
                {
                    width: 350,
                    url: 'https://vacacionesreales.com.mx/',
                    nombre: '',
                    text: 'Sitio web de Tours los Cabos BCS', 
                    image: 'images/body/logo-Visita-Los-Cabos.png'
                },
                {
                    width: 200,
                    url: 'https://lapazmexicotours.com/',
                    nombre: 'La Paz Tours',
                    text: 'Sitio web de Tours en La Paz, BCS', 
                    image: 'images/body/Logo-LaPazTours.png'
                },
                {

                    width: 200,
                    url: 'https://corason.com.mx/',
                    nombre: 'C.O.R.A.S.O.N.',
                    text: 'Sitio web Centro Organizado de Recursos Alimentarios y Servicios Omnímodos para Niños A. C.',
                    image: 'images/body/logo-Corason.png'
                },
                {

                    width: 250,
                    url: 'https://www.botellaalmar.com.mx/',
                    nombre: '',
                    text: 'Sitio web medio electrónico de cultura y política.', 
                    image: 'images/body/logo-Botella-Al-Mar.svg'
                },
                {

                    width: 550,
                    url: 'https://casahogarsanfrancisco.org/',
                    nombre: '',
                    text: 'Sitio web de San Francisco de Asís y La Niña Milagrosa A.C cinco años', 
                    image: 'images/body/logo-Casa-Hogar-SanFranciso.png'
                },
                {

                    width: 450,
                    url: 'https://metropolimx.com/',
                    nombre: '',
                    text: 'Metropolimx sitio web de noticias La Paz', 
                    image: 'images/body/logo-metropolimx.svg'
                }
            ]
        }
    }
}
</script>

<style>
    .imgSitioWeb{
        margin-top: 25px;
        margin-bottom: 45px;
    }
    .nombreSitioWeb{
        font-size: 1.4em;
        text-align: left;
        font-weight: bolder;
        position: relative;
        bottom: 45px;
        text-align: center;
    }
    .nombreSitioWeb h4{
        color: orange;
    }
    .icon svg {
        height: 25px !important;
    }
</style>